<template>
  <div>
    <el-table
      id="rebateSetTable"
      :data="list"
      ref="table"
      :max-height="tableHeight"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.1)"
      :default-sort="{ prop: 'date', order: 'ascending' }"
      class="summarytable"
    >
      <el-table-column
        v-for="item in column"
        :prop="item.key"
        :label="item.name"
        :key="item.key"
        :fixed="item.fixed"
        :width="item.width"
        align="center"
      >
        <template #header>
          <span>{{ item.name }}</span>
          <!-- <span style="margin-left: 10px" v-if="item.copy">
          <i
            @click.stop="onClick(item.key, item.name, item.percent, item.unit)"
            class="el-icon-document-copy"
          >
          </i
        ></span> -->
        </template>

        <el-table-column
          v-for="item in item.children"
          :prop="item.key"
          :label="item.name"
          :key="item.key"
          :width="item.width"
          align="center"
          :sortable="item.sort"
          :sort-method="item.sortMethod"
        >
          <template #header>
            <span>{{ item.name }}</span>
          </template>
          <template slot-scope="scope">
            <span
              >{{ scope.row[item.key] ? item.unit : null
              }}{{
                Number(scope.row[item.key]) &&
                item.key !== "campaign" &&
                item.point
                  ? scope.row[item.key].toFixed(item.point)
                  : scope.row[item.key]
                  ? scope.row[item.key]
                  : "-"
              }}{{ scope.row[item.key] ? item.percent : null }}</span
            >
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import XLSX from "xlsx";
import FileSaver from "file-saver";
export default {
  props: {
    fathercolumn: { type: Array, default: () => [] },
    column: { type: Array, default: () => [] },
    loading: Boolean,
  },
  data() {
    return {
      tableHeight: window.innerHeight - 280,
    };
  },
  methods: {
    downLoadFileToExcel() {
      let fix = document.querySelector(".el-table__fixed");
      var xlsxParam = { raw: true }; //导出的内容只做解析，不进行格式转换(添加此行代码表格中的百分比就不会再导出的时候被转换成小数点)
      let wb;
      if (fix) {
        //判断要导出的节点中是否有fixed的表格，如果有，转换excel时先将该dom移除，然后append回去
        wb = XLSX.utils.table_to_book(
          document.querySelector("#rebateSetTable").removeChild(fix),
          xlsxParam
        );
        document.querySelector("#rebateSetTable").appendChild(fix);
      } else {
        wb = XLSX.utils.table_to_book(
          document.querySelector("#rebateSetTable"),
          xlsxParam
        );
      }
      let wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          "汇总.xlsx"
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    },
  },
  computed: {
    list: function () {
      return this.$store.state.Summary.PredictDataList;
    },
  },
};
</script>